import environment from '@/plugins/environment'
import activityJsonUtil from '@/utils/activityJson-util'
import { remapImageTokens, LABPlayer } from './lab'
import q from 'q'
import lppPagesUtil from '@/utils/lpp-pages-util'
import { idAuthenticator } from '@/plugins/auth'
import * as _ from 'lodash'
import objectBuilder from '@/utils/object-builder'
import { LAB } from '../enums/clients'
import { LAB_TYPE, IMAGE_TYPE, WBP_TYPE } from '../enums/render-type'
import { WHOLE_CLASS, WORKSPACE, HANDOUT } from '../enums/collaborative-activity-type'

const COLLABORATIVE_ACTIVITIES = [WHOLE_CLASS, WORKSPACE, HANDOUT]
/**
 * Extracts the ActivityInfo for each activity that has a webWidget.
 * @param lpp
 * @param previews
 * @param previewsIndex
 * @returns {requiresStudentDevices, previewerList}
 */
let extractInfo = (lpp, previews, previewsIndex) => {
  let deferred = q.defer()
  if (previews.length === 0) {
    return null
  }
  let promises = []
  let pages = lppPagesUtil.resolvePagesArray(previewsIndex, lpp).map(x => {
    return x.pageContent
  })
  let previewerList = []
  for (let i = 0; i < previews.length; i++) {
    if (typeof pages[i] !== 'undefined') {
      pages[i].webWidgets = pages[i].webWidgets || { widgets: [] }
      let pageWidgets = pages[i].webWidgets.widgets
      if (Object.values(pageWidgets).length > 0) {
        for (let pageWidget of Object.values(pageWidgets)) {
          if (pageWidget.activityJson !== undefined) {
            let activityJSON = activityJsonUtil.resolve(pageWidget.activityJson)
            let promise = extractInfoByActivity(activityJSON).then(info => {
              previewerList[i] = createActivityInfo(
                previews[i],
                info.activityInfo,
                pageWidget
              )
            })
            promises.push(promise)
          } else {
            previewerList[i] = createActivityInfo(previews[i])
          }
        }
      } else {
        previewerList[i] = createActivityInfo(previews[i])
      }
    } else {
      previewerList[i] = createActivityInfo(previews[i])
    }

    q.all(promises)
      .then(() => {
        deferred.resolve({
          requiresStudentDevices: !!previewerList.filter(f => f.collaboration)
            .length,
          previewerList
        })
      })
      .catch(deferred.reject)
  }
  return deferred.promise
}

/**
 * Create the options object supplied to the LAB API, which provides the ActivityInfo from the ActivityJson
 * @param activityJson
 * @returns {*}
 */
let extractInfoByActivity = activityJson => {
  let actJson = activityJson

  let options = {
    root: environment.serviceUrlFor(LAB),
    environment: environment.getEnv(),
    activity: actJson,
    launchMode: 'assessment',
    language: 'en_US', // Todo, fix in beta two with localisation.
    hideClose: true,
    id: idAuthenticator.getAccessToken()
  }

  let activityInfo = null
  return getLabActivityInfo(actJson, options).then(info => {
    activityInfo = info
    return {
      activityInfo
    }
  })
}
/**
 *Creates the ActivityInfo object needed for a specific page
 * @param preview
 * @param collaboration
 * @param activityType
 * @return {preview,thumbnailError,collaboration,activityType,renderType,color,icon,activity}
 */
let createActivityInfo = (preview, info, pageWidget) => {
  let activityInfo = {}
  let activity = {}
  let previewAsset = {}
  let thumbnailError = false

  if (_.isUndefined(info) || _.isEmpty(info)) {
    info = objectBuilder
      .resolve()
      .set('collaboration', false)
      .build()
  }
  if (preview.thumbnailError) {
    previewAsset = preview.url
    thumbnailError = preview.thumbnailError
  } else {
    previewAsset = preview
  }
  if (pageWidget) {
    activity = remapImageTokens(pageWidget.activityJson, pageWidget.persistJson)
  }
  activityInfo = objectBuilder
    .resolve()
    .set('collaboration', info.collaboration)
    .set('renderType', renderType(pageWidget, info))
    .set('activityType', info.activityType)
    .set('color', info.color)
    .set('icon', info.icon)
    .set('activity', activity)
    .set('preview', previewAsset)
    .set('thumbnailError', thumbnailError)
    .build()
  return activityInfo
}

/**
 *Defines the renderType, this is used to select the Lesson Renderer
 * @param renderType
 * @param collaboration
 * @return String
 */
let renderType = (pageWidget, info) => {
  if (_.isUndefined(pageWidget)) {
    return IMAGE_TYPE
  }
  if (COLLABORATIVE_ACTIVITIES.includes(info.activityType)) {
    return WBP_TYPE
  } else if (pageWidget.type === LAB_TYPE && info.collaboration) {
    return IMAGE_TYPE
  } else if (pageWidget.type) {
    return pageWidget.type
  } else {
    return IMAGE_TYPE
  }
}

let getLabActivityInfo = (activityJson, options) => {
  let deferred = q.defer()
  LABPlayer.getActivityInfo(
    activityJson,
    activityInfo => {
      deferred.resolve(activityInfo)
    },
    options
  )

  return deferred.promise
}

export default {
  extractInfo,
  extractInfoByActivity,
  createActivityInfo
}
